<script>
import options from "./AiAssistant.options"

export default options
</script>

<template>
    <article class="nyk-ai-assistant" :class="{'nyk-ai-assistant--expanded': expanded}">
        <div class="nyk-visually-hidden" 
            aria-live="polite" 
            aria-atomic="true"
            v-html="awaitingResponse ? ariaLabels.screenReaderSpecificResponseLoaderLabel || 'Vent venligst' : $store.getters['aiAssistant/screenReaderResponseText']">
        </div>
        
        <div ref="pageContainer" 
            class="nyk-ai-assistant__page" 
            :class="{
                'nyk-hero-topic-pages': viewport === 'large' || viewport === 'xLarge' || !expanded, 
                'nyk-ai-assistant__page--expanded': expanded
            }">
            <h1 ref="pageHeroContainer" class="nyk-hero-topic-pages__subject">
                <span ref="pageHeadlineContainer"  class="nyk-hero-topic-pages__subject__headline">{{ labels.headline }}</span>
            </h1>

            <SearchInputField
                v-if="!expanded"
                :hero="labels.searchHeroLabel"
                :maxLength="configs.inputMaxLength"
                type="ai-assistant"
                :hint="expanded ? '' : hint" 
                :onChangeCallback="updateSearchKeyword" 
                :onEnterCallback="search" 
                :searchResetAriaLabel="labels?.searchResetAriaLabel" 
                :searchInputAriaLabel="labels?.searchInputAriaLabel" 
                :searchIconLabel="labels?.searchIconLabel" 
                :searchButtonAriaLabel="labels?.searchButtonAriaLabel" 
                :compact="false"
            />

            <div ref="messagesContainer" v-if="expanded" class="nyk-ai-assistant__messages">
                <div v-for="(message, index) in messages" 
                    :key="`${message.id}-${index}`" 
                    :class="{ 'nyk-ai-assistant__messages_item--separator': message.type === 'separator', 'nyk-ai-assistant__messages_item--user': message.source === 'user' }"
                    :aria-hidden="message.type === 'separator' ? 'true' : undefined">
                    <div v-if="message.isScrollAnchor" class="nyk-ai-assistant__messages__scroll-anchor"></div>
                    <transition 
                        v-if="message.type !== 'separator'"
                        :name="message.source === 'user' ? 'nyk-transition-fade-slide-right' : 'nyk-transition-fade-scale-up'" 
                        appear
                    >
                        <chat-message
                            appearance="plain"
                            size="large"
                            :is-user="message.source === 'user'"
                            :message="message" 
                            :labels="labels"
                            @on-action="handleAction"
                            @on-external-link="handleExternalLink"
                            @on-feedback="handleFeedback">    
                        </chat-message>
                    </transition>
                </div>
                <div v-if="actionTaken" class="nyk-ai-assistant__messages__scroll-anchor"></div>

                <div v-if="awaitingResponse" class="nyk-ai-assistant__response-loader">
                    <div class="nyk-ai-assistant__response-loader-dots"></div>
                </div>
            </div>
        </div>
        <transition name="nyk-transition-slide-vertical">
            <div  v-if="expanded" class="nyk-ai-assistant__input--sticky" 
                :class="{
                    'nyk-hero-topic-pages': viewport === 'large' || viewport === 'xLarge',
                }">
                <div class="nyk-hero-topic-pages__subject"></div>

                <SearchInputField
                    :hero="labels.searchHeroLabel"
                    :placeholder="labels.inputPlaceholder"
                    :maxLength="configs.inputMaxLength"
                    type="ai-assistant"
                    :hint="expanded ? '' : labels.disclaimer" 
                    :initSearchParam="query" 
                    :onChangeCallback="updateSearchKeyword" 
                    :onEnterCallback="search" 
                    :searchResetAriaLabel="labels?.searchResetAriaLabel" 
                    :searchInputAriaLabel="labels?.searchInputAriaLabel" 
                    :searchIconLabel="labels?.searchIconLabel" 
                    :searchButtonAriaLabel="labels?.searchButtonAriaLabel" 
                    :compact="false"
                />
            
            </div>
         </transition>
    </article>
</template>